import * as actionTypes from './actionTypes';

interface State {
  show: boolean;
  message: string;
}

const initialState: State = {
  show: false,
  message: ''
}

export const flashMessage = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.OPEN_FLASH_MESSAGE:
      return {
        show: action.show,
        message: action.message
      };
    case actionTypes.CLOSE_FLASH_MESSAGE:
      return {
        show: action.show,
        message: ''
      };
    default:
      return state;
  }
}
